{
	"dependencies": {
		"@mairistem/composants": "^0.8.8",
		"@mairistem/comptabilite": "^0.4.115",
		"@mairistem/fiche": "^0.11.9",
		"@mairistem/finances-utils": "^0.5.62",
		"@mairistem/liste": "^0.11.4",
		"@mairistem/module": "^0.10.8",
		"@mairistem/pdf": "^0.2.8",
		"@mairistem/piecesjointes": "^0.2.12",
		"@mairistem/tools": "^0.4.10",
		"@rc-component/virtual-list": "^1.6.0",
		"@sentry/react": "^10.78.0",
		"@vitejs/plugin-react": "^6.1.2",
		"dayjs": "^1.11.23",
		"lodash": "^4.18.1",
		"pdfjs-dist": "^5.7.284",
		"react": "^18.3.1",
		"react-dom": "^18.3.1",
		"react-router": "^5.3.4",
		"react-router-dom": "^5.3.4",
		"react-toastify": "^11.2.0",
		"rsuite-table": "5.19.2",
		"vite": "^8.3.5",
		"zustand": "5.0.15"
	},
	"description": "Gestion de la comptabilité",
	"devDependencies": {
		"@biomejs/biome": "^2.6.4",
		"@testing-library/jest-dom": "^6.10.0",
		"@testing-library/react": "^16.3.3",
		"@testing-library/user-event": "^14.6.8",
		"@types/bun": "^1.4.4",
		"@types/lodash": "^4.17.27",
		"@types/react": "^19.3.0",
		"@types/react-dom": "^19.3.0",
		"@types/react-router": "^5.1.20",
		"@types/react-router-dom": "^5.3.3",
		"@vitest/coverage-v8": "^4.1.12",
		"esbuild": "^0.28.2",
		"happy-dom": "^20.14.6",
		"typescript": "^6.0.3",
		"vitest": "^4.1.12"
	},
	"license": "Proprietary",
	"name": "app-comptabilite",
	"overrides": {
		"@mairistem/tools": "0.4.10"
	},
	"scripts": {
		"build": "NODE_OPTIONS='--max-old-space-size=8096' vite build",
		"build:app": "NODE_OPTIONS='--max-old-space-size=8096' vite build --mode app",
		"lint": "biome check .",
		"lint:fix": "biome check --write .",
		"start": "NODE_ENV=development vite dev",
		"test": "vitest",
		"test:unit": "vitest run"
	},
	"type": "module",
	"version": "0.1.11-beta.37"
}
